import state from './moduleCommentState.js'
import mutations from './moduleCommentMutations.js'
import actions from './moduleCommentAction.js'
import getters from './moduleCommentGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
